import { render, staticRenderFns } from "./boxComponent.vue?vue&type=template&id=371a1256&scoped=true&"
import script from "./boxComponent.vue?vue&type=script&lang=js&"
export * from "./boxComponent.vue?vue&type=script&lang=js&"
import style0 from "./boxComponent.vue?vue&type=style&index=0&id=371a1256&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371a1256",
  null
  
)

export default component.exports